/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import {map, Observable} from 'rxjs';

import {transformJsonObjectProperty} from '../../../components/util/adn-http-resource-transforms';
import {AdnApiClientService} from '../../common/controller/adn-api-client.service';
import {
  SignalAdminResourceApiBase,
  SignalAdminResourceListParams,
  SignalAdminResourceModel,
  SignalAdminResourcePage
} from '../../common/controller/signal-admin-resource-api';

export interface NetworkDataModel extends SignalAdminResourceModel {
  [key: string]: any;
}

const jsonTransforms = transformJsonObjectProperty('data');

@Injectable({providedIn: 'root'})
export class NetworkDataApiService extends SignalAdminResourceApiBase<NetworkDataModel> {
  constructor(client: AdnApiClientService) {
    super(client, 'networkdata');
  }

  override get(id: string): Observable<NetworkDataModel> {
    return super.get(id).pipe(map((model) => jsonTransforms.transformResponse(model)));
  }

  override list(params: SignalAdminResourceListParams): Observable<SignalAdminResourcePage<NetworkDataModel>> {
    return super.list(params).pipe(map((page) => ({
      ...page,
      results: (page.results || []).map((model) => jsonTransforms.transformResponse(model))
    })));
  }

  listOptions(params: Record<string, any> = {}): Observable<SignalAdminResourcePage<NetworkDataModel>> {
    return this.client.request<SignalAdminResourcePage<NetworkDataModel>>({
      method: 'GET',
      url: this.resourceUri('networkdata'),
      params
    }).pipe(map((page) => ({
      ...page,
      results: (page.results || []).map((model) => jsonTransforms.transformResponse(model))
    })));
  }

  override save(model: NetworkDataModel): Observable<NetworkDataModel> {
    const payload = jsonTransforms.transformRequest(model);
    return super.save(payload).pipe(map((saved) => jsonTransforms.transformResponse(saved)));
  }
}
